module.exports = __webpack_public_path__ + "static/content-wordpress-4-571ac4a5c61de0de67d59c94bcc3e979.jpg";